
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

type RequestListHeaderProps = {
  type: 'sent' | 'received';
  isCandidat: boolean;
  isEntreprise: boolean;
};

const RequestListHeader = ({ type, isCandidat, isEntreprise }: RequestListHeaderProps) => {
  const navigate = useNavigate();
  
  const title = type === 'sent' 
    ? (isCandidat ? "Mes demandes de feedback" : "Demandes de feedback envoyées") 
    : "Demandes de feedback reçues";
  
  const description = type === 'sent'
    ? (isCandidat 
        ? "Liste des demandes de feedback que vous avez envoyées aux recruteurs" 
        : "Liste des demandes de feedback que vous avez envoyées aux candidats")
    : (isCandidat
        ? "Liste des demandes de feedback que vous avez reçues des recruteurs"
        : "Liste des demandes de feedback que vous avez reçues des candidats");

  const handleRequestClick = () => {
    navigate('/request-feedback');
  };

  return (
    <>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      {type === 'sent' && (
        <div className="flex justify-end px-6 mb-4">
          <Button onClick={handleRequestClick}>
            {isCandidat ? "Demander un feedback" : "Nouvelle demande"}
          </Button>
        </div>
      )}
    </>
  );
};

export default RequestListHeader;
